import React, { useState } from "react";
import BackBtn from "../components/BackBtn";
import SaveBadge from "../components/SaveBadge";
import Modal from "../components/Modal";
import LessonCard from "../components/LessonCard";
import DrillCard from "../components/DrillCard";
import { ColorBtn, Toggle, Author, Btn, LibIcon, Label, StarBtn } from "../components/ui";
import { FF, T, EXTRA_LEVEL } from "../lib/constants";
import { BASE_COLORS, baseColor } from "../lib/library";

// Eén les of oefening uit de bibliotheek bekijken of (als het van jou is) bewerken.
export default function LibItem({
  mob, pd, item, sav, clubId, clubName, solo, isOwn, canModerate, canEditOfficial, planColors,
  onBack, backLabel, onField, onPart, onCopy, onDelete, fav, onToggleFav,
}) {
  var [confirm, setConfirm] = useState(false);
  if (!item) return null;
  var isPlan = item.src === "plan";
  var isLesson = item.kind === "lesson";
  var canEdit = !!isOwn || (isPlan && !!canEditOfficial);
  var lv = isLesson ? (item.level || baseColor(item.color, planColors)) : EXTRA_LEVEL;

  var ownerLine = !isPlan && !isOwn ? <Author name={item.ownerName} prefix="Gedeeld door " size={22} /> : null;
  var copiedLine = item.copiedFrom && isOwn ? <span style={{ fontSize: 12, color: T.muted }}>{"Gekopieerd van " + item.copiedFrom}</span>
    : (isPlan && item.planLabel ? <span style={{ fontSize: 12, color: T.muted }}>{"Uit " + item.planLabel + (item.week ? ", week " + item.week + (item.les ? " les B" : " les A") : "")}</span> : null);

  var editBlock = canEdit ? (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {isLesson && (
        <div>
          <Label>Kleur</Label>
          <div style={{ display: "grid", gridTemplateColumns: mob ? "repeat(3, minmax(0, 1fr))" : "repeat(5, minmax(0, auto))", gap: 6, justifyContent: "start" }}>
            {BASE_COLORS.map(function (c0) { var c = baseColor(c0.key, planColors);
              return <ColorBtn key={c.key} lv={c} active={item.color === c.key} height={40} text={mob && c.key === "volwassenen" ? "Volw." : c.label}
                onClick={function () { onField("color", c.key); }} style={mob ? null : { padding: "0 14px" }} />;
            })}
          </div>
        </div>
      )}
      {!solo && !isPlan && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 14, background: T.soft, border: "1px solid " + T.line, borderRadius: 12, padding: "12px 14px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
            <span style={{ width: 36, height: 36, borderRadius: 10, background: item.shared ? "#2F7D47" : T.primary, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}><LibIcon name={item.shared ? "share" : "lock"} /></span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: T.ink }}>Delen met mijn club</div>
              <div style={{ fontSize: 13, color: T.muted, lineHeight: 1.4 }}>{item.shared
                ? "Trainers van " + (clubName || "je club") + " zien " + (isLesson ? "deze les" : "deze oefening") + " onder ‘Club’, met jouw naam erbij."
                : "Alleen jij ziet " + (isLesson ? "deze les" : "deze oefening") + "."}</div>
            </div>
          </div>
          <Toggle on={!!item.shared} label="Delen met mijn club" onClick={function () { onField("shared", !item.shared); }} />
        </div>
      )}
    </div>
  ) : null;

  var extra = (ownerLine || copiedLine) ? <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>{ownerLine}{copiedLine}</div> : null;
  var canDelete = isOwn || (isPlan && canEditOfficial) || (!isPlan && canModerate && item.shared);

  return (
    <div style={{ maxWidth: isLesson ? 1100 : 800, margin: "0 auto", padding: "12px " + pd + "px 48px", fontFamily: FF, boxSizing: "border-box" }}>
      <SaveBadge show={sav} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <BackBtn label={backLabel} onClick={onBack} />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          {onToggleFav && <StarBtn on={fav} label={item.name || ""} onClick={onToggleFav} size={26} />}
          {canDelete && <Btn kind="danger" onClick={function () { setConfirm(true); }}>Verwijderen</Btn>}
          {!isOwn && <Btn kind="secondary" onClick={onCopy}><LibIcon name="copy" size={16} />{isLesson ? "Kopiëren naar mijn lessen" : "Kopiëren naar mijn oefeningen"}</Btn>}
          {isOwn && <Btn kind="secondary" onClick={onCopy} title="Maak een kopie"><LibIcon name="copy" size={16} />Dupliceren</Btn>}
        </div>
      </div>

      {isLesson
        ? <LessonCard mob={mob} item={item} lv={lv} canEdit={canEdit} onField={onField} onPart={onPart} extra={extra} top={editBlock}
            meta={isPlan && item.week ? ("Week " + item.week + " · Les " + (item.les ? "B" : "A")) : null} />
        : <DrillCard mob={mob} item={item} lv={lv} sectionLabel={isOwn ? "Mijn oefening" : "Oefening van de club"} canEdit={canEdit} clubId={clubId}
            onField={onField} extra={(extra || editBlock) ? <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>{extra}{editBlock}</div> : null} />}

      {confirm && (
        <Modal onClose={function () { setConfirm(false); }}>
          <h3 style={{ fontSize: 18, color: "#B83232", margin: "0 0 8px", fontWeight: 800, fontFamily: FF }}>{isLesson ? "Les verwijderen?" : "Oefening verwijderen?"}</h3>
          <p style={{ fontSize: 14, color: T.muted, margin: "0 0 16px", lineHeight: 1.5, fontFamily: FF }}>
            {isOwn || isPlan ? "Dit kan niet ongedaan worden gemaakt." + (isPlan ? " De les verdwijnt voor alle clubs uit de bibliotheek; het seizoensplan zelf blijft zoals het is." : "") : "Je verwijdert dit als hoofdtrainer uit de club. " + (item.ownerName || "De maker") + " raakt het dan ook kwijt."}
          </p>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn kind="secondary" onClick={function () { setConfirm(false); }} style={{ flex: 1 }}>Annuleren</Btn>
            <Btn onClick={function () { setConfirm(false); onDelete(); }} style={{ flex: 1, background: "#B83232" }}>Verwijderen</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}
